import { O365MailWebComponent } from './component/O365MailWebComponent';
import { WEB_COMPONENT_SENSOR_O365_MAIL } from '../../../webcomponents.constants';

export { O365MailWebComponent };

window.customElements.define(WEB_COMPONENT_SENSOR_O365_MAIL, O365MailWebComponent);
